import { render, staticRenderFns } from "./AnnouncementsDetail.vue?vue&type=template&id=b4c79ed8&"
import script from "./AnnouncementsDetail.vue?vue&type=script&lang=js&"
export * from "./AnnouncementsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports